import { IFormInput } from "global-states";
import { atom } from "recoil";
import { v4 } from "uuid";
import { ISignInCredType, ISignInScreensTypes } from "./types";

export const IsSignInTermAndConditionEnabledState = atom({
  key: v4(),
  default: false,
});

export const SignInFormState = atom<IFormInput[]>({
  key: v4(),
  default: [],
});

export const userLoginCredRespState = atom<{
  userId?: string;
  requestId?: string;
}>({
  key: v4(),
  default: {},
});

export const SignInScreenState = atom<ISignInScreensTypes>({
  key: v4(),
  default: "loading",
});

export const CurrentAuthCredState = atom<ISignInCredType>({
  default: "phone",
  key: v4(),
});

export const IsVerifiedUserState = atom({
  key: v4(),
  default: false,
});

export const SigninLoadingState = atom({
  key: v4(),
  default: false,
});

export const BrowserRegistrationModalState = atom({
  key: v4(),
  default: false,
});

export const BrowserRegistrationWaitingModalState = atom({
  key: v4(),
  default: false,
});


export const LoadingMethodSelectionState = atom({
  key: v4(),
  default: {
    index: 0,
    loading: false,
  },
});